import Swiper, { Navigation} from 'swiper';

Swiper.use([Navigation]);

const swiper = new Swiper('.reviews__content', {
  slidesPerView: 2,
  spaceBetween: 24,
  navigation: {
    nextEl: '.reviews__slider-btn--next',
    prevEl: '.reviews__slider-btn--prev',
  },
  breakpoints: {
    320:{
      slidesPerView: 1,
    },
    769:{
      slidesPerView:2,
    }
  },
});
